import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet
} from 'react-native';

import {
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib';

import { pt } from '../../common/utils';

import img from '../../common/img';

class LoadingAnimation extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <View style={st.contain}>
                <JDImage style={st.img} source={img.loading_animation}></JDImage>
                <JDText style={st.text}>努力加载中...</JDText>
            </View>
        )
    }
}

const st = StyleSheet.create({
    contain: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: pt(10),
        backgroundColor: '#F3F5F7'
    },
    img: {
        height: pt(20),
        width: pt(20)
    },
    text: {
        marginLeft: pt(10)
    }
});

export default LoadingAnimation;